﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceKeeperContract = void 0;
const PriceKeeperABI_1 = require("./abi/PriceKeeperABI");
const ContractFacade_1 = require("./abstact/ContractFacade");
class PriceKeeperContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, PriceKeeperABI_1.PriceKeeperABI.GetABI());
    }
    getPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._toEther(yield this._call("getPrice", "1000000000000000000"));
        });
    }
    getCorrectionIndex() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._toEther(yield this._call("getCorrectionIndex"));
        });
    }
    setCorrectionIndex(corIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const wei = this._toWei(corIndex + "");
            const res = this._send("setCorrectionIndex", wei);
            return res;
        });
    }
    getQuoteToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._call("getQuoteToken");
        });
    }
}
exports.PriceKeeperContract = PriceKeeperContract;
//# sourceMappingURL=PriceKeeperContract.js.map